export const COMPANY_ID = 'tripadvisor'
export const COMPANY_NAME = 'Trip Advisor'
